import { useState } from 'react';
import ImageStorage from '../../utils/ImageStorage';

interface Props {
  isShow: boolean;
  setShow: (value: boolean) => void;
  detail: {
    pc: string;
    mobile: string;
  };
  name: string;
  desc: string;
  handleClickPrev: () => void;
  handleClickNext: () => void;
}

const CharacterDetailModal = ({
  isShow,
  setShow,
  detail,
  name,
  desc,
  handleClickPrev,
  handleClickNext,
}: Props) => {
  const clazzShowModal = isShow ? 'modal-open' : '';

  return (
    <div id='character-detail-modal' className={`${clazzShowModal}`}>
      <div className='modal-content'>
        <div
          className='detail-modal-bg'
          style={{ backgroundImage: `url(${detail?.pc})` }}
        ></div>
        <div
          className='detail-modal-bg-mobile'
          style={{ backgroundImage: `url(${detail?.mobile})` }}
        ></div>
        <div
          className='navigate-btn'
          id='prev'
          onClick={handleClickPrev}
          style={{ cursor: 'pointer' }}
        ></div>
        <div
          className='navigate-btn'
          id='next'
          onClick={handleClickNext}
          style={{ cursor: 'pointer' }}
        ></div>
        <div
          id='close-modal-btn'
          onClick={() => {
            setShow(false);
          }}
        >
          <img src={ImageStorage.ButtonClose} />
        </div>
        {/*  */}
        <div className='lg:w-1/2 w-full h-full flex flex-col lg:pt-16 lg:pb-16 pb-8 pt-4 items-center'>
          <div className='character-name'>
            {name}
            <div className='character-name-overlay'>{name}</div>
          </div>
          <div className='separator'></div>
          <div className='character-desc flex-1 px-16'>{desc}</div>
          <div className='separator'></div>
        </div>
      </div>
    </div>
  );
};

export default CharacterDetailModal;
